:host div#OpportunityTypeSelectorStage {
    min-width: 300px;
}
